import _extends from "@babel/runtime/helpers/extends";
import { useTheme } from "@smartsheet/lodestar-core";
import React, { forwardRef } from "react";
import { ToastContentStyled } from "../styled/ToastContentStyled";
export const ToastContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(ToastContentStyled, _extends({
    themeMode: themeMode
  }, rest, {
    ref: ref
  }), children);
});
ToastContent.displayName = "ToastContent";
//# sourceMappingURL=ToastContent.js.map